import React from "react";
import { Box, Group, ActionIcon, Tooltip } from "@mantine/core";
import { IconMoon, IconSun } from "@tabler/icons-react";
import EditorRealtimeFooter from "./EditorRealtimeFooter";
import { toolbar } from "../styleFile";
import { getEditorChromeTheme } from "../utils/editorChromeTheme";
import { useObjectStore } from "../zustand/objects";

/**
 * Editor-aligned chrome for preview routes: top bar + realtime footer.
 * Viewport canvases: wrap with `previewCanvasFrameStyle` and put R3F `<Canvas>` in `previewCanvasWebGlStyle` (styleFile).
 */
const PreviewChrome = ({
  connected,
  lastSaveAt,
  lastRemoteUpdateAt,
  toolbarLeading,
  toolbarTrailing,
  isDarkTopBar = false,
}) => {
  const topBarTheme = getEditorChromeTheme(isDarkTopBar);
  const viewportThemeOverride = useObjectStore((s) => s.viewportThemeOverride);
  const toggleViewportThemeOverride = useObjectStore((s) => s.toggleViewportThemeOverride);
  return (
    <>
      <Box
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 200,
          pointerEvents: "none",
        }}
      >
        <Box
          style={{
            ...toolbar.toolbarContainer,
            pointerEvents: "auto",
            backgroundColor: topBarTheme.bg,
            borderBottom: `1px solid ${topBarTheme.border}`,
          }}
        >
          <Group justify="space-between" align="center" wrap="wrap" w="100%" gap="md">
            <Box
              style={{
                flex: "1 1 180px",
                minWidth: 0,
                display: "flex",
                alignItems: "center",
              }}
            >
              {toolbarLeading}
            </Box>
            <Group
              gap={8}
              wrap="wrap"
              justify="flex-end"
              align="center"
              style={{
                border: `1px solid ${topBarTheme.border}`,
                borderRadius: 6,
                padding: "4px 8px",
                backgroundColor: topBarTheme.hoverBg,
              }}
            >
              <Tooltip
                label={
                  viewportThemeOverride === "dark"
                    ? "Switch 3D viewport to light mode"
                    : "Switch 3D viewport to dark mode"
                }
              >
                <ActionIcon
                  size={28}
                  radius="md"
                  variant="transparent"
                  color={topBarTheme.icon}
                  onClick={toggleViewportThemeOverride}
                  style={{
                    backgroundColor: "transparent",
                    border: "1px solid transparent",
                  }}
                >
                  {viewportThemeOverride === "dark" ? <IconMoon size={16} /> : <IconSun size={16} />}
                </ActionIcon>
              </Tooltip>
              {toolbarTrailing}
            </Group>
          </Group>
        </Box>
      </Box>
      <Box style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 200 }}>
        <EditorRealtimeFooter
          connected={connected}
          lastSaveAt={lastSaveAt}
          lastRemoteUpdateAt={lastRemoteUpdateAt}
        />
      </Box>
    </>
  );
};

export default PreviewChrome;
